import { useState } from "react";

function AdminCsvUpload() {
  const [file, setFile] = useState(null);
  const [mensagem, setMensagem] = useState("");
  const [erros, setErros] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleUpload = async () => {
    if (!file) return;

    const token = localStorage.getItem("token");
    const formData = new FormData();
    formData.append("file", file);

    setLoading(true);
    setMensagem("");
    setErros([]);

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/admin/cashback/csv`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "Erro ao processar CSV");

      setMensagem(`✅ CSV processado com sucesso. Total de linhas: ${data.total}`);
      setErros(data.erros || []);
    } catch (err) {
      console.error(err);
      setMensagem(`❌ Erro: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-2xl mx-auto p-6 bg-white shadow rounded">
      <h1 className="text-2xl font-bold mb-4">Upload de CSV - Cashback Manual</h1>

      <input
        type="file"
        accept=".csv"
        onChange={(e) => setFile(e.target.files[0])}
        className="mb-4"
      />

      <button
        onClick={handleUpload}
        disabled={!file || loading}
        className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 disabled:opacity-50"
      >
        {loading ? "Processando..." : "Enviar CSV"}
      </button>

      {mensagem && (
        <div className="mt-4 text-sm text-gray-800">{mensagem}</div>
      )}

      {erros.length > 0 && (
        <div className="mt-4 text-red-600 text-sm">
          <h3 className="font-bold mb-2">Erros encontrados:</h3>
          <ul className="list-disc pl-5">
            {erros.map((err, i) => (
              <li key={i}>{err.motivo} — linha: {JSON.stringify(err.row)}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

export default AdminCsvUpload;
